import React from 'react';
import type { BackendUiConfig } from '@/services/backend';

export const defaultUiConfig: BackendUiConfig = {
  showTopbarLogo: true,
  showFooter: false,
  footerHtml: '',
};

export const UiConfigContext = React.createContext<BackendUiConfig>(defaultUiConfig);

export const useUiConfig = (): BackendUiConfig => React.useContext(UiConfigContext);